import { ReadMore } from "@Utilities/ReadMore";
export class SelectGroupPage
{
	private readonly _changeEventName = "change";
	private readonly _containerSelector = ".row";
	private readonly _groupItemSelector = ".js-group";
	private readonly _groupItemCountSelector = ".js-group-size-count";
	private readonly _idAttributeName = "id";
	private readonly _nameAttributeName = "name";
	private readonly _readClampSelector = ".readClamp";
	private readonly _selectTag = "select";
	private readonly _sizeSelector = ".js-group select";
	private readonly _spanTag = "SPAN";
	private readonly _submitButtonSelector = ".js-group-submit";

	constructor()
	{
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		const sizeLists = document.querySelectorAll(this._sizeSelector);

		sizeLists.forEach(item =>
		{
			item.addEventListener(this._changeEventName, (event) =>
			{
				const select = event.target as HTMLSelectElement;

				this.HandleSizeSelected(select);
			});
		});

		this.UpdateItemCount();
		this.ConfigureReadMore();
	}

	private CloneSize(select: HTMLSelectElement): void
	{
		const container = select.closest(this._containerSelector) as HTMLElement;
		const allItems = container.querySelectorAll(this._groupItemSelector);
		const lastItem = allItems[allItems.length - 1] as HTMLElement;
		const oldIndex = allItems.length - 1;
		const newIndex = allItems.length;
		const newItem = lastItem.cloneNode(true) as HTMLElement;

		for (const child of newItem.children)
		{
			const element = child as HTMLElement;

			if (element.tagName === this._spanTag)
			{
				if (element.dataset.valmsgFor != "")
				{
					element.dataset.valmsgFor = element.dataset.valmsgFor.replace(oldIndex.toString(), newIndex.toString());
				}
			}
			else
			{
				element.setAttribute(this._idAttributeName, element.getAttribute(this._idAttributeName).replace(oldIndex.toString(), newIndex.toString()));
				element.setAttribute(this._nameAttributeName, element.getAttribute(this._nameAttributeName).replace(oldIndex.toString(), newIndex.toString()));
			}
		}

		lastItem.after(newItem);
		const allselects = container.querySelectorAll(this._selectTag);
		const lastSelect = allselects[allselects.length - 1] as HTMLSelectElement;

		lastSelect.addEventListener(this._changeEventName, (event) =>
		{
			const select = event.target as HTMLSelectElement;

			this.HandleSizeSelected(select);
		});
	}

	public ConfigureReadMore = (): void =>
	{
		const readClamp: NodeListOf<HTMLElement> = document.querySelectorAll(this._readClampSelector);

		if (readClamp.length > 0)
		{
			readClamp.forEach(clamp =>
			{
				new ReadMore(clamp);
			});
		}
	};

	private HandleSizeSelected(select: HTMLSelectElement): void
	{
		const container = select.closest(this._containerSelector) as HTMLElement;
		const allItems = container.querySelectorAll(this._sizeSelector);
		const lastItem = allItems[allItems.length - 1] as HTMLElement;
		const itemValue = select.value;

		if (select.id == lastItem.id && itemValue !== "")
		{
			this.CloneSize(select);
		}

		this.UpdateItemCount();
	}

	private UpdateItemCount(): void
	{
		const sizeLists = document.querySelectorAll(this._sizeSelector);
		let sizeCount = 0;

		sizeLists.forEach(item =>
		{
			const select = item as HTMLSelectElement;
			const itemValue = select.value;

			if (itemValue != "")
			{
				sizeCount++;
			}
		});

		const spanGroupSize = document.querySelector(this._groupItemCountSelector) as HTMLElement;
		spanGroupSize.innerHTML = sizeCount.toString();

		const btnSubmit = document.querySelector(this._submitButtonSelector) as HTMLInputElement;

		if (sizeCount > 1)
		{
			btnSubmit.disabled = false;
		}
		else
		{
			btnSubmit.disabled = true;
		}
	}
}